import Icon from '@/components/ui/AppIcon';

interface StatItem {
  label: string;
  value: string;
  icon: string;
  color: string;
}

const QuickStats = () => {
  const stats: StatItem[] = [
    {
      label: 'Total Conditions',
      value: '847',
      icon: 'DocumentTextIcon',
      color: 'text-blue-600'
    },
    {
      label: 'Body Systems',
      value: '11',
      icon: 'CubeIcon',
      color: 'text-green-600'
    },
    {
      label: 'Rating Levels',
      value: '10+',
      icon: 'ChartBarIcon',
      color: 'text-purple-600'
    },
    {
      label: 'Last Updated',
      value: 'Jan 2026',
      icon: 'ClockIcon',
      color: 'text-orange-600'
    }
  ];

  return (
    <div data-component-id="src/app/va-disability-database/components/QuickStats.tsx:39:4" data-component-path="src/app/va-disability-database/components/QuickStats.tsx" data-component-line="39" data-component-end-line="60" data-component-file="QuickStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20lg%3Agrid-cols-4%20gap-4%20mb-8%22%7D" className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {stats.map((stat, index) => (
        <div data-component-id="src/app/va-disability-database/components/QuickStats.tsx:41:8" data-component-path="src/app/va-disability-database/components/QuickStats.tsx" data-component-line="41" data-component-end-line="58" data-component-file="QuickStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-card%20rounded-lg%20shadow-subtle%20p-6%20border%20border-border%20hover%3Ashadow-elevation%20transition-smooth%22%7D"
          key={index}
          className="bg-card rounded-lg shadow-subtle p-6 border border-border hover:shadow-elevation transition-smooth"
        >
          <div data-component-id="src/app/va-disability-database/components/QuickStats.tsx:45:10" data-component-path="src/app/va-disability-database/components/QuickStats.tsx" data-component-line="45" data-component-end-line="54" data-component-file="QuickStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20space-x-3%20mb-2%22%7D" className="flex items-center space-x-3 mb-2">
            <Icon data-component-id="src/app/va-disability-database/components/QuickStats.tsx:46:12" data-component-path="src/app/va-disability-database/components/QuickStats.tsx" data-component-line="46" data-component-end-line="50" data-component-file="QuickStats.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" 
              name={stat.icon as any} 
              size={24} 
              className={stat.color}
            />
            <span data-component-id="src/app/va-disability-database/components/QuickStats.tsx:51:12" data-component-path="src/app/va-disability-database/components/QuickStats.tsx" data-component-line="51" data-component-end-line="53" data-component-file="QuickStats.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-2xl%20font-bold%20text-primary%20font-headline%22%7D" className="text-2xl font-bold text-primary font-headline">
              {stat.value}
            </span>
          </div>
          <p data-component-id="src/app/va-disability-database/components/QuickStats.tsx:55:10" data-component-path="src/app/va-disability-database/components/QuickStats.tsx" data-component-line="55" data-component-end-line="57" data-component-file="QuickStats.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-text-secondary%20font-body%22%7D" className="text-sm text-text-secondary font-body">
            {stat.label}
          </p>
        </div>
      ))}
    </div>
  );
};

export default QuickStats;